import { createReducer } from '@reduxjs/toolkit';

import { clearPostWarehouseParts } from '../../../actions/coilovers/warehouse/patchWarehouse';
import postWarehouse from '../../../thunks/coilovers/warehouse/postWarehouse';

const initialState = {
  loading: false,
  error: null,
  data: {},
};

const postWarehouseReducer = createReducer(initialState, {
  [postWarehouse.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [postWarehouse.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [postWarehouse.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearPostWarehouseParts]: () => initialState
});

export default postWarehouseReducer;
